import { Stack } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { CategoryField } from 'categories/components';
import { useGetPublishedPartFinderProductTypes } from 'companySettings/hooks';
import { IPartFinderProductType } from 'companySettings/types';
import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';

// Step 1: the family's name, the product type it builds on - only a published one, since a family
// takes its attributes from the product type's release - and its category.
export const DetailsStep = () => {
  const { t } = useTranslation();

  const { control, errors } = useFormContext();

  const { records: productTypeOptions = [], isLoading } = useGetPublishedPartFinderProductTypes();

  return (
    <Stack gap={2}>
      {/* No core Form around the wizard's fields, so each one takes the form's control itself. */}
      <FormField
        name="name"
        type={InputType.TEXT_INPUT}
        inputProps={{ control, error: errors?.name, label: t('labelName'), required: true }}
      />

      <FormField
        name="productTypeId"
        type={InputType.SELECT}
        inputProps={{
          control,
          error: errors?.productTypeId,
          label: t('labelProductType'),
          required: true,
          disabled: isLoading,
          options: productTypeOptions,
          getValue: (productType: IPartFinderProductType) => productType.id,
          getLabel: (productType: IPartFinderProductType) => productType.name,
        }}
      />

      <CategoryField
        name="category"
        allItemsLabel={t('labelAllCategories')}
        isRootExcluded
        required
      />
    </Stack>
  );
};
